<app-terminal-overlay
    [title]="title()"
    subtitle="{{ 'GENERAL.SUBTITLE.SELECT_BATCH' | translate }}"
    icon="fa-location-dot"
    (closeRequested)="onCloseRequested()"
    data-test="batch-selector-page"
>
    <priva-filter-search
        header
        [config]="filterSearchConfig"
        [dataSource]="batchDataSource"
        class="batch-filter__search"
        data-test="search-batch-bar"
    />

    <div class="batch-selector__overview">
        @if (batchList.length) {
            <priva-table
                class="batch-table"
                type="separate"
                [rows]="batchList"
                [disableSelect]="true"
                [hasHeader]="false"
                (rowClick)="onTableRowClick($event)"
                data-test="batch-list-table"
            >
                <ng-template priva-table-column="Name" let-item="row" [isContentWrapped]="true">
                    {{ item.name }}
                </ng-template>
            </priva-table>
        } @else {
            <priva-notification>{{ 'ERROR.TITLE.NO_BATCHES_FOUND' | translate }}</priva-notification>
        }
    </div>
</app-terminal-overlay>
